import { render, staticRenderFns } from "./LocalcodeReport.vue?vue&type=template&id=4d6bc1f4&scoped=true&"
import script from "./LocalcodeReport.vue?vue&type=script&lang=js&"
export * from "./LocalcodeReport.vue?vue&type=script&lang=js&"
import style0 from "./LocalcodeReport.vue?vue&type=style&index=0&id=4d6bc1f4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6bc1f4",
  null
  
)

export default component.exports